import { Button, Typography, Icon, useDeviceType } from 'pixel-react';
import { useNavigate } from 'react-router-dom';

import { SignUpWrapper } from '../SignUpWrapper';
import styles from './PasswordChangeSuccess.module.scss';

export const PasswordChangeSuccess = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const { isMobile } = useDeviceType();
  const navigate = useNavigate();
  const handleSubmit = async () => {
    navigate('/signin');
  };

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            The all-in-one <br /> Integrated Testing <br /> Platform
          </Typography>{' '}
        </>
      }
      sub_content={`Revolutionize your workflow with ${clientName}, seamlessly integrating third-party tools and offering versatile cross-platform testing.`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.success_password_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.success_password_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="user_password_lock"
            />
          </section>
          <section className={styles.success_password_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Password Changed <br />
              Successfully
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              New password has been set successfully you can now securely access
              your account with your new password.
            </Typography>
          </section>

          <div className={styles.success_password_footerbtn}>
            <Button
              buttonWidth="151px"
              type="submit"
              variant="primary"
              onClick={handleSubmit}
            >
              <Typography fontSize="16px" className={styles['register_btn']}>
                Back to Sign In
              </Typography>
            </Button>
          </div>
        </aside>
      </section>
    </SignUpWrapper>
  );
};
